export enum  Languages {
    Hebrew = 'Hebrew',
    Arabic = 'Arabic',
    English = 'English',
}